'use client';
import FormMultipleSelect from '@form/FormMultipleSelect';
import FormSelectMultiple from '@form/FormSelectMultiple';
import FormSingleDropzone from '@form/FormSingleDropzone';
import FormTextarea from '@form/FormTextarea';

import React from 'react';
import { AutoCompleteTextInput } from '../AutoCompleteTextInput';
import FormTextInput, { type FormTextInputProps } from './FormTextInput';
import FormAddress from './FormAddress';
import FormCheckbox from './FormCheckbox';
import { FormCodeEditor } from './FormCodeEditor';
import { FormColorPicker } from './FormColorPicker';
import FormDatePicker from './FormDatePicker';
import { FormDropzone } from './FormDropzone';
import { FormIBAN } from './FormIBAN';
import { FormSelect } from './FormSelect';
import FormSubmit from './FormSubmit';
import { FormOptionCards } from './FormOptionCards';
import { FormSwitch } from './FormSwitch';
import { FormTypeahead } from './FormTypeahead';
import { FormularPicker } from './FormularPicker';
import FormWeekdays from './FormWeekdays';
import { FormWYSIWYG } from './FormWYSIWYG';
import TimeRange from './TimeRange';
import TimeRangesInput from './TimeRangesInput';

type Props = FormTextInputProps;

const FormInput = (props: Props) => <FormTextInput {...props} />;

interface SubComponents {
    Address: typeof FormAddress;
    AutoComplete: typeof AutoCompleteTextInput;
    Checkbox: typeof FormCheckbox;
    Code: typeof FormCodeEditor;
    Color: typeof FormColorPicker;
    DatePicker: typeof FormDatePicker;
    Dropzone: typeof FormDropzone;
    File: typeof FormSingleDropzone;
    Files: typeof FormDropzone;
    MultipleSelect: typeof FormMultipleSelect;
    OptionCards: typeof FormOptionCards;
    Formular: typeof FormularPicker;
    IBAN: typeof FormIBAN;
    TimeRange: typeof TimeRange;
    TimeRangesInput: typeof TimeRangesInput;
    Select: typeof FormSelect;
    SelectMultiple: typeof FormSelectMultiple;
    Submit: typeof FormSubmit;
    Switch: typeof FormSwitch;
    Textarea: typeof FormTextarea;
    Typeahead: typeof FormTypeahead;
    WYSIWYG: typeof FormWYSIWYG;
    Weekdays: typeof FormWeekdays;
}

FormInput.AutoComplete = AutoCompleteTextInput;
FormInput.Textarea = FormTextarea;
FormInput.DatePicker = FormDatePicker;
FormInput.Checkbox = FormCheckbox;
FormInput.Select = FormSelect;
FormInput.SelectMultiple = FormSelectMultiple;
FormInput.Address = FormAddress;
FormInput.WYSIWYG = FormWYSIWYG;
FormInput.Files = FormDropzone;
FormInput.File = FormSingleDropzone;
FormInput.Dropzone = FormInput.Files;
FormInput.Submit = FormSubmit;
FormInput.Color = FormColorPicker;
FormInput.Code = FormCodeEditor;
FormInput.Switch = FormSwitch;
FormInput.TimeRange = TimeRange;
FormInput.TimeRangesInput = TimeRangesInput;
FormInput.IBAN = FormIBAN;
FormInput.Formular = FormularPicker;
FormInput.Typeahead = FormTypeahead;
FormInput.Weekdays = FormWeekdays;
FormInput.MultipleSelect = FormMultipleSelect;
FormInput.OptionCards = FormOptionCards;

export default FormInput as React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> & SubComponents;
